import { Link } from "react-router-dom";
import { SOBRE } from "@nhomi/conteudo";
import { APP_VERSION } from "@/lib/version";
import { TopBar } from "@/ui/primitives";
import { TextoLongo } from "@/ui/TextoLongo";

/* Fora do Guard, como a privacidade: a loja pede um lugar público que
   explique o que o app é e quem responde por ele.

   O texto vem de `@nhomi/conteudo`, uma vez só para o site e para o app.
   A VERSÃO não: ela é deste pacote, e dizer a do site na tela do app
   seria mentir sobre qual código está rodando. */

export function Sobre() {
  return (
    <main className="screen">
      <TopBar title="Sobre" back="/" />
      <div className="screen-body pad texto-longo selecionavel">
        <TextoLongo blocos={SOBRE} />

        <p className="fine">
          <Link to="/privacidade">Política de privacidade</Link> · <Link to="/seguranca-infantil">Segurança infantil</Link>
        </p>
        <p className="fine">Versão {APP_VERSION}</p>
        <div className="gap" />
      </div>
    </main>
  );
}
